export default {
      id: "heart-outline-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#heart-outline-usage",
      toString: function () {
        return this.url;
      }
    }